var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PsTabulator',{ref:_vm.tabulatorRef,attrs:{"data":_vm.data,"options":_vm.fullOptions},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }